export var MindInterface;
(function (MindInterface) {
    var SelectNodeType;
    (function (SelectNodeType) {
        SelectNodeType[SelectNodeType["NORMAl"] = 0] = "NORMAl";
        SelectNodeType[SelectNodeType["ROOT"] = 1] = "ROOT";
        SelectNodeType[SelectNodeType["DETACHED_ROOT"] = 2] = "DETACHED_ROOT";
        SelectNodeType[SelectNodeType["SUMMARY"] = 3] = "SUMMARY";
        SelectNodeType[SelectNodeType["BOUNDARY"] = 4] = "BOUNDARY";
    })(SelectNodeType = MindInterface.SelectNodeType || (MindInterface.SelectNodeType = {}));
    var EditResultCode;
    (function (EditResultCode) {
        EditResultCode[EditResultCode["SUCCESS"] = 0] = "SUCCESS";
        EditResultCode[EditResultCode["ERROR"] = 1] = "ERROR";
    })(EditResultCode = MindInterface.EditResultCode || (MindInterface.EditResultCode = {}));
    var MindEventNames;
    (function (MindEventNames) {
        MindEventNames["SELECT_NODE_CHANGE"] = "SELECT_NODE_CHANGE";
    })(MindEventNames = MindInterface.MindEventNames || (MindInterface.MindEventNames = {}));
})(MindInterface || (MindInterface = {}));
//# sourceMappingURL=mind.js.map